module.exports = __webpack_public_path__ + "static/cat__box-4fd8d630119080d7546f878f692b9fbe.webp";